import Vue from "vue"; 
import store from "@/store";
import VueI18n from "vue-i18n"; 



Vue.use(VueI18n);
// set default lang

 
 const i18n = new VueI18n({
     locale: "en",
     messages: {}
 });

 export async function loadMessages (locale) {
    if (Object.keys(i18n.getLocaleMessage(locale)).length === 0) {
      const messages = await import( `@/lang/${locale}`);
      i18n.setLocaleMessage(locale, messages);
    }
  
    if (i18n.locale !== locale) {
      i18n.locale = locale;
    }
  }
  
  (async function() {
      // loadMessages('en')
      loadMessages(store.getters["lang/locale"]);
  })();
  
  export default i18n;